import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import Swal from "sweetalert2";
import "./assets/scss/theme.scss";

class App extends Component {
  idleTimeout = 20 * 60 * 1000; 
  idleTimer = null;
  activityEvents = ["mousemove", "keydown", "scroll", "click", "touchstart"];

  isNavigating = false;

  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  componentDidMount() {
    this.setupIdleTimer();
    window.addEventListener("beforeunload", this.handleWindowClose);
    //document.addEventListener("visibilitychange", this.handleVisibilityChange);

    const authUser = localStorage.getItem("authUser");

    try {
      const user = JSON.parse(authUser);
      if (!user && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    } catch (e) {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
  }

  componentWillUnmount() {
    this.cleanupIdleTimer();
    window.removeEventListener("beforeunload", this.handleWindowClose);
    //document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  andleWindowClose = (e) => {
  try {
    const navEntry = performance.getEntriesByType("navigation")[0];
    const navType = navEntry?.type;

    if (navType !== "reload") {
      localStorage.clear();
    }
  } catch (error) {
    // Fallback: assume it's not a refresh
    localStorage.clear();
  }
};

  // Detect if user is navigating rather than closing tab
  handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      this.isNavigating = true;
    } else {
      this.isNavigating = false;
    }
  };

  setupIdleTimer = () => {
    this.activityEvents.forEach((event) =>
      window.addEventListener(event, this.resetIdleTimer)
    );
    this.resetIdleTimer();
  };

  resetIdleTimer = () => {
    if (this.idleTimer) clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(this.logoutUser, this.idleTimeout);
  };

  cleanupIdleTimer = () => {
    this.activityEvents.forEach((event) =>
      window.removeEventListener(event, this.resetIdleTimer)
    );
    if (this.idleTimer) clearTimeout(this.idleTimer);
  };

  logoutUser = () => {
    const isLoginPage = window.location.pathname === "/login";

    if (isLoginPage) {
      localStorage.clear();
    } else {
      Swal.fire({
        title: "Session Expired",
        text: "You have been logged out due to inactivity.",
        icon: "warning",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        localStorage.clear();
        window.location.href = "/login";
      });
    }
  };

  getLayout = () => {
    let layoutCls = VerticalLayout;
    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();

    return (
      <React.Fragment>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
              />
            ))}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

App.propTypes = {
  layout: PropTypes.object,
};

export default connect(mapStateToProps, null)(App);
